import { getProduto } from 'config/produto-env';
import { HeaderElbb } from 'pages/HomeElbb/components/Header';
import { Header } from 'pages/HomePublic/components/Header';

/** Menu do portal do produto, para as páginas comuns ao Prêmio BB e ao ELBB. */
export function HeaderProduto({ currentPage }: { currentPage: 'pre-inscricao' }) {
  return getProduto() === 'PREMIO_ELBB' ? <HeaderElbb currentPage={currentPage} /> : <Header currentPage={currentPage} />;
}
